import {useEffect, useRef} from "react";
import {useDispatch, useSelector} from "react-redux";
import * as tutorialActions from "store/actions/tutorial";
import {showPopUp} from "components/PopUp";
import CertificatePopup from "components/PopUp/CertificatePopup";
import InputButtonPopup from "components/PopUp/FillButtonPopup/InputButton";
import OneButtonPopup from "components/PopUp/FillButtonPopup/OneButton";
import ocpMissionData from "./ocpMissionData.json";
import View from "./View";

function Container() {
  const slideRef = useRef(null);

  const dispatch = useDispatch();
  const missionIdx = useSelector(state => state.tutorial.missionIdx);
  const completedMissionIdx = useSelector(state => state.tutorial.completedMissionIdx);
  const contentsId = useSelector(state => state.tutorial.contentsId);

  const currentTemplateIdx = Number(contentsId?.split("_")[1]) || 0;
  const {title, template, totalMissionNum} = ocpMissionData[currentTemplateIdx];
  const lastMissionNum = totalMissionNum - 1;

  const missions = JSON.parse(template).missions;
  const currentMission = missions[missionIdx];

  useEffect(() => {
    window.addEventListener("TUTORIAL_MISSION_SUCCESS", handleMissionSuccess);
    window.addEventListener("TUTORIAL_MISSION_FAIL", handleMissionFail);
    return () => {
      window.removeEventListener("TUTORIAL_MISSION_SUCCESS", handleMissionSuccess);
      window.addEventListener("TUTORIAL_MISSION_FAIL", handleMissionFail);
    };
  }, [missionIdx]);

  useEffect(() => {
    slideRef?.current.scrollTo(0, 0);
  }, [missionIdx]);

  const handleMissionSuccess = () => {
    handleCompletedMissionIdxToNext();
    moveToNext();
  };

  const handleCompletedMissionIdxToNext = () => {
    if (completedMissionIdx < missionIdx) {
      dispatch(tutorialActions.handleTutorialCompletedMissionIdx(missionIdx));
    }
  };

  const moveToNext = () => {
    if (missionIdx !== lastMissionNum) {
      dispatch(tutorialActions.handleTutorialMission(missionIdx + 1));
    } else {
      showPopUp(<InputButtonPopup title={title} onClick={showCertificatePopup} button="ID_CERTIFICATE_GETTING" />, {defaultPadding: false});
    }
  };

  const showCertificatePopup = (name, groupName) => {
    showPopUp(<CertificatePopup title={title} name={name} groupName={groupName} />, {
      defaultPadding: false,
      dismissOverlay: true,
      noBackground: true,
    });
  };

  const handleMissionFail = () => {
    showPopUp(<OneButtonPopup titleId="ID_CODE_ERROR_TITLE" contentId="ID_CODE_ERROR_CONTENT" />, {defaultPadding: false});
  };

  const onClickCloseBtn = () => {
    dispatch(tutorialActions.handleTutorialPanel());
  };

  const onClickMenuBtn = () => {
    dispatch(tutorialActions.handleTutorialList());
  };

  const onClickNextBtn = () => {
    dispatch(tutorialActions.handleTutorialMission(missionIdx + 1));
  };

  const onClickPrevBtn = () => {
    if (missionIdx > 0) {
      dispatch(tutorialActions.handleTutorialMission(missionIdx - 1));
    }
  };

  return (
    <View
      title={title}
      slideRef={slideRef}
      missionIdx={missionIdx}
      missions={missions}
      currentMission={currentMission}
      completedMissionIdx={completedMissionIdx}
      totalMissionNum={totalMissionNum}
      onClickCloseBtn={onClickCloseBtn}
      onClickMenuBtn={onClickMenuBtn}
      onClickNextBtn={onClickNextBtn}
      onClickPrevBtn={onClickPrevBtn}
    />
  );
}

export default Container;
